import { faFileInvoiceDollar, faHome, faMonitorWaveform, faShop, faStars, faShieldCheck, faDollar } from "@fortawesome/pro-light-svg-icons"
import {
    SUPPORT_ADMIN_ROUTE,
    SUPPORT_ENTITIES_ROUTE,
    SUPPORT_ADMIN_HEALTH_ROUTE,
    SUPPORT_ADMIN_HEALTH_SERVER_MEMORY_ROUTE,
    SUPPORT_ADMIN_INVOICING_BASIS_FOR_INVOICING_ROUTE,
    SUPPORT_ADMIN_INVOICING_ROUTE,
    SUPPORT_FEATURES_ROUTE,
    SUPPORT_ADMIN_HEALTH_SCHEDULER_ROUTE,
    SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH_ROUTE,
    SUPPORT_ADMIN_HEALTH_ADYEN_ROUTE,
    SUPPORT_ADMIN_GDPR_ROUTE,
    SUPPORT_ADMIN_PAYMENTS_ROUTE,
} from "../../../../constants/routes"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"

export function SupportAdminNavItems() {
    return (
        <>
            <LocalizedStrict id="support-nav-item-home">
                <NavMenuItem icon={faHome} dest={SUPPORT_ADMIN_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-entities-access">
                <NavMenuItem icon={faShop} dest={SUPPORT_ENTITIES_ROUTE}>
                    Entities
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-payments">
                <NavMenuItem icon={faDollar} dest={SUPPORT_ADMIN_PAYMENTS_ROUTE}>
                    Payments
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-features">
                <NavMenuItem icon={faStars} dest={SUPPORT_FEATURES_ROUTE}>
                    Features
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-invoicing" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    icon={faFileInvoiceDollar}
                    dest={SUPPORT_ADMIN_INVOICING_ROUTE}
                    title="Invoicing"
                >
                    <LocalizedStrict id="support-nav-item-invoicing-basis-for-invoicing">
                        <NavMenuSubItem route={SUPPORT_ADMIN_INVOICING_BASIS_FOR_INVOICING_ROUTE}>
                            Basis for invoicing
                        </NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-health-title" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faMonitorWaveform} dest={SUPPORT_ADMIN_HEALTH_ROUTE} title="Health">
                    <LocalizedStrict id="support-nav-item-health-scheduler">
                        <NavMenuSubItem route={SUPPORT_ADMIN_HEALTH_SCHEDULER_ROUTE}>Scheduler</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="support-nav-item-health-database">
                        <NavMenuSubItem route={SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH_ROUTE}>
                            Database health
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="support-nav-item-health-server-memory">
                        <NavMenuSubItem route={SUPPORT_ADMIN_HEALTH_SERVER_MEMORY_ROUTE}>Server memory</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="support-nav-item-health-adyen">
                        <NavMenuSubItem route={SUPPORT_ADMIN_HEALTH_ADYEN_ROUTE}>Adyen</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="support-nav-item-gdpr">
                <NavMenuItem icon={faShieldCheck} dest={SUPPORT_ADMIN_GDPR_ROUTE}>
                    GDPR
                </NavMenuItem>
            </LocalizedStrict>
        </>
    )
}
